var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon-hover",on:{"mouseover":function($event){_vm.hovering = true},"mouseout":function($event){_vm.hovering = false}}},[_c('i-icon',{class:_vm.hovering ? 'i-text-neutral-90' : 'i-text-neutral-70',attrs:{"symbol":_vm.symbol,"size":_vm.size}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }